import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import A from '../../common/A';
// import usePadLogin from '../../../hooks/usePadLogin';
import { URL } from '../../../constant';
import { appKillOnOff, emailRegExp, hideSplash, logoutRemoveStorage, openWebBrowser } from '../../../utils/utilityEtc';
import {
  useInput,
  useGmAppLogin,
} from '../../../hooks';

function Login() {
  const history = useHistory();
  const [gmAppLogin, loginResult] = useGmAppLogin();

  const [ emailCheck, setEmailCheck] = useState('');
  const [pwCheck, setPwCheck] = useState('');
  const [isLoginChk, setIsLoginChk] = useState(localStorage.getItem('mathpidLoginChk'));

  const [ pw, onChangePw, onPwReset ] = useInput('');
  const [ email, onChangeEmail, onEmailReset] = useInput('');
  const autoLoginEmail = localStorage.getItem('access.email');
  
  
  useEffect(() => {
    hideSplash();

    localStorage.removeItem('access.token');
    localStorage.removeItem('access.starToken');
    
    logoutRemoveStorage()
    appKillOnOff('Y');
    return () => appKillOnOff('N');
  }, []);

  useEffect(() => {
    onChangeEmail(autoLoginEmail ? autoLoginEmail : '');
  }, [autoLoginEmail])

  useEffect(() => {
    setPwCheck(loginResult);
  }, [loginResult])

  const onBlur = useCallback(() => {
    if (!email) return;
    // 이메일 양식이 맞으면  true 아니면 false;
    const result = emailRegExp(email);
    setEmailCheck(result ? 'success' : 'fail');
  }, [email]);

  const handleChange = (e) => {
    const { name } = e.target;
    if (name === 'email') {
      setEmailCheck('');
      onChangeEmail(e);
    } else if (name === 'loginChk') {
      const checked = e.target.checked;
      let result = isLoginChk;
      if (checked) result = 'Y';
      else result = 'N';
      
      localStorage.setItem('mathpidLoginChk', result);
      setIsLoginChk(result)
    }
  }

  const handleLogin = async () => {
    if (!pw || !email) return;

    try {
      gmAppLogin(pw, email);
    } catch (error) {
      console.log("##### error handleLogin: ", error);
    }
  }

  const handlePrivacyPolicy = useCallback(() => {
    // openWebBrowser(URL)
    try {
      openWebBrowser("https://wjtb-prd-pub.s3.ap-northeast-2.amazonaws.com/brs/barosem/html/privacy_policy.htm")
    } catch (error) {
      window.open("https://wjtb-prd-pub.s3.ap-northeast-2.amazonaws.com/brs/barosem/html/privacy_policy.htm", "개인정보보호방침");  
    }
  }, [])

  return (
    <div className="layout-def with_bottom_area log_in gm">
      <div className="container">
        <div className="inner">
          <div className="center_wrap">
            <div className="logo_wrap">
              <div className="logo">
                <img
                  src="./static/images/common/logo_ai_barosem.svg"
                  alt=""
                />
              </div>
              <div className="txt1">
                AI바로셈 입회 회원만 <br className="hide_pc hide_t"></br>이용할
                수 있는 서비스입니다.
              </div>
            </div>

            <div className="input_wrap">
              <form>
                <article>
                  <div className="input_cont">
                    <div className="input_box white_box h56">
                      <input
                        type="email"
                        value={email}
                        name="email"
                        placeholder="email"
                        onChange={handleChange}
                        onBlur={onBlur}
                      />
                      <div className="r_area">
                        {(emailCheck === 'success' && email.length > 0) && <img src="./static/images/icon/ic_check.svg" alt="" />}
                        {emailCheck === 'fail' && (
                          <button type="button" onClick={onEmailReset}>
                            < img src="./static/images/icon/ic_error.svg" alt="" />
                          </button>
                        )}
                        {(emailCheck === '' && email.length > 0) && (
                          <button type="button" onClick={onEmailReset}>
                            <img src="./static/images/icon/input_delete_40.svg" alt=""/>
                          </button>
                        )}
                      </div>
                    </div>
                    {
                      emailCheck === 'fail' && (
                        <div className="info_txt red">
                          올바른 이메일 형식이 아닙니다. 예)abc@mathpid.com
                        </div>
                      )
                    }
                  </div>
                </article>
                <article>
                  <div className="input_cont">
                    <div className="input_box white_box h56">
                      <input
                        value={pw}
                        type="password"
                        placeholder="password"
                        onChange={onChangePw}
                      />
                      <div className="r_area">
                        {/* <img src="./static/images/icon/ic_check.svg" alt="" /> */}
                        {/* <img src="./static/images/icon/ic_error.svg" alt="" /> */}
                        {(pw.length > 0) && (
                          <button type="button" onClick={onPwReset}>
                            <img src="./static/images/icon/input_delete_40.svg" alt="" />
                          </button>
                        )}
                      </div>
                    </div>
                    {
                      pwCheck === 'fail' && (
                        <div className="info_txt red">
                          이메일 주소와 비밀번호가 일치하지 않습니다.
                        </div>
                      )
                    }
                  </div>
                </article>
              </form>
            </div>
            <div className="lower_wrap cls">
              <div className="left">
                <div className="custom-radio-wrap gray">
                  <input
                    type="checkbox"
                    id="login_chk"
                    name="loginChk"
                    checked={isLoginChk === 'Y'}
                    onChange={handleChange}
                  />
                  <label htmlFor="login_chk">로그인 상태 유지</label>
                </div>
              </div>
              <div className="right cls">
                <A onClick={() => history.push(URL.ACCOUNT.PW_INQUIRY)}>비밀번호 찾기</A>
              </div>
            </div>
            <div className="lower_wrap2">
              <button
                // disabled={
                //   !emailRegExp(email)
                //   || !pw
                // }
                className="btn btn-blue"
                onClick={handleLogin}
              >LOGIN</button>
            </div>
            <div className="btn_wrap1 two">
              <A 
                className="btn btn-gray1"
                onClick={() => openWebBrowser('http://m.wjthinkbig.com/product/subject/detail.do?subjectId=S0000053', 'openInWebBrowser')}
              >
                회원신청
              </A>
              <A
                style={{cursor: 'pointer'}}
                className="btn btn-dark"
                onClick={() => history.push(URL.ACCOUNT.GM_MEMBER_AUTH)}
              >
                회원인증
              </A>
            </div>
            <div
              className="cs_call" 
            >
              고객센터 1577-1500&nbsp;&nbsp;&nbsp;｜&nbsp;&nbsp;&nbsp;
              <A onClick={handlePrivacyPolicy}>개인정보처리방침</A>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;